import { PREFIX_PRODUCER } from "@/api/Model/ProductOwnerModel";
import AbstractLloydsRiskCode from "../LloydsRiskCode";

class LloydsRiskCode extends AbstractLloydsRiskCode {
  static getResourceEndpoint() {
    return PREFIX_PRODUCER + '/product-lloyds-risk-codes-ipr';
  }
}

export default LloydsRiskCode;
